// extracted by mini-css-extract-plugin
export default {"pattern-gradient":"DiningOptions_pattern-gradient__QJa6J","delivery-options":"DiningOptions_delivery-options__v93QW"};